import markIcon from "assets/icons/mark.svg";
import arrowDown from "assets/icons/arrowDown.svg";
import arrowUp from "assets/icons/arrowUp.svg";
import carrotDown from "assets/icons/carrotDown.svg";
import carrotDownGreen from "assets/icons/carrotDownGreen.svg";
import carrotDownRed from "assets/icons/carrotDownRed.svg";

import filter from "assets/icons/filter.svg";
import filterDetail from "assets/icons/filterDetail.svg";
import settings from "assets/icons/settings.svg";
import logo from "assets/icons/logo.svg";
import empty from "assets/icons/empty.svg";
import filterTable from "assets/icons/filterTable.svg";
import download from "assets/icons/download.svg";

import patientStatus1 from "assets/icons/statuses/patientStatus1.svg";
import patientStatus2 from "assets/icons/statuses/patientStatus2.svg";
import patientStatus3 from "assets/icons/statuses/patientStatus3.svg";
import patientStatus4 from "assets/icons/statuses/patientStatus4.svg";
import clinicActiveStatus from "assets/icons/statuses/clinicActiveStatus.svg";
import clinicDisabledStatus from "assets/icons/statuses/clinicDisabledStatus.svg";
import coachInvitedStatus from "assets/icons/statuses/coachInvitedStatus.svg";
import coachExpiredStatus from "assets/icons/statuses/coachExpiredStatus.svg";
import coachRegisteredStatus from "assets/icons/statuses/coachRegisteredStatus.svg";

import status from "assets/icons/status.svg";

import verticalDots from "assets/icons/verticalDots.svg";

import information from "assets/icons/information.svg";
import patientAppointment from "assets/icons/patientOverview/patientAppointmentIcon.svg";
import patientExams from "assets/icons/patientOverview/patientExamsIcon.svg";
import patientGoals from "assets/icons/patientOverview/patientGoalsIcon.svg";
import patientProgress from "assets/icons/patientOverview/patientProgressIcon.svg";
import patientUser from "assets/icons/patientOverview/patientUserIcon.svg";
import patientShoulder from "assets/icons/patientOverview/shoulder.svg";
import modalClose from "assets/icons/manageement/modalClose.svg";
import profile from "assets/icons/profile.svg";

import calendar from "assets/icons/calendar.svg";

export const icons = {
  markIcon,
  arrowDown,
  arrowUp,
  carrotDown,
  carrotDownGreen,
  carrotDownRed,
  filter,
  filterDetail,
  settings,
  logo,
  empty,
  filterTable,
  coachExpiredStatus,
  status,
  verticalDots,
  information,
  download,

  patientStatus1,
  patientStatus2,
  patientStatus3,
  patientStatus4,
  coachInvitedStatus,
  coachRegisteredStatus,
  clinicActiveStatus,
  clinicDisabledStatus,

  patientAppointment,
  patientExams,
  patientGoals,
  patientProgress,
  patientUser,
  patientShoulder,

  calendar,
  profile,
  modalClose,
};
